<div class="container-fluid">
  <!-- Dispo Report Form -->
  <div class="card mb-4">
    <div class="card-header bg-light">
      <h5 class="mb-0">Dispo Report</h5>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <!-- Date Range -->
        <div class="col-md-6">
          <label class="form-label">From date</label>
          <input type="date" class="form-control" [(ngModel)]="filters.dateFrom" name="dateFrom">
        </div>
        <div class="col-md-6">
          <label class="form-label">To date</label>
          <input type="date" class="form-control" [(ngModel)]="filters.dateTo" name="dateTo">
        </div>
        
        <!-- Time Range -->
        <div class="col-md-6">
          <label class="form-label">From time</label>
          <input type="time" class="form-control" [(ngModel)]="filters.timeFrom" name="timeFrom">
        </div>
        <div class="col-md-6">
          <label class="form-label">To time</label>
          <input type="time" class="form-control" [(ngModel)]="filters.timeTo" name="timeTo">
        </div>
        
        <!-- Dropdown Filters -->
        <div class="col-md-6">
          <label class="form-label">Dispo</label>
          <select class="form-select" [(ngModel)]="filters.dispo" name="dispo">
            <option value="">All</option>
            <option *ngFor="let option of dispoOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
        
        <div class="col-md-6">
          <label class="form-label">Campaign</label>
          <select class="form-select" [(ngModel)]="filters.campaign" name="campaign">
            <option value="">All</option>
            <option *ngFor="let option of campaignOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
        
        <div class="col-md-6">
          <label class="form-label">Caller</label>
          <select class="form-select" [(ngModel)]="filters.caller" name="caller">
            <option value="">All</option>
            <option *ngFor="let option of callerOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
        
        <div class="col-md-6">
          <label class="form-label">User</label>
          <select class="form-select" [(ngModel)]="filters.user" name="user">
            <option value="">All</option>
            <option *ngFor="let option of userOptions" [value]="option.value">{{option.label}}</option>
          </select>
        </div>
        
        <!-- Checkbox Options -->
        <div class="col-12">
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="showAll" [(ngModel)]="filters.showAll" name="showAll">
            <label class="form-check-label" for="showAll">Show All</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="checkbox" id="showOnlyMine" [(ngModel)]="filters.showOnlyMine" name="showOnlyMine">
            <label class="form-check-label" for="showOnlyMine">Show Only Mine</label>
          </div>
        </div>
        
        <!-- Action Buttons -->
        <div class="col-12">
          <button class="btn btn-primary me-2" (click)="onSearch()">
            <i class="fas fa-search me-1"></i> Search
          </button>
          <button class="btn btn-outline-secondary" (click)="onReset()">
            <i class="fas fa-undo me-1"></i> Reset
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Data Table -->
  <div class="card">
    <div class="card-header bg-light d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Disposition Records</h5>
      <input 
        type="text" 
        class="form-control w-25" 
        placeholder="Search..." 
        (keyup)="updateFilter($event)">
    </div>
    <div class="card-body">
      <ngx-datatable
        #dispoTable
        class="bootstrap"
        [rows]="rows"
        [columns]="columns"
        [columnMode]="ColumnMode.force"
        [headerHeight]="50"
        [footerHeight]="50"
        [rowHeight]="'auto'"
        [limit]="10"
        [selected]="selected"
        [selectionType]="SelectionType.checkbox"
        (select)="onSelect($event)">
        
        <!-- Custom loading template -->
        <ngx-datatable-loading>
          Loading data...
        </ngx-datatable-loading>
        
        <!-- No data template -->
        <ngx-datatable-no-results>
          No data found
        </ngx-datatable-no-results>
        
      </ngx-datatable>
    </div>
  </div>
</div>